var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.componentInitialized)?_c('component-loader',{key:_vm.$i18n.locale,attrs:{"component-name":_vm.componentName,"default-component-name":_vm.defaultComponentName,"id":"monitoring-component"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }